import React from 'react';
import { Accordion, Button, Input, Radio, Segment } from 'semantic-ui-react';
import Icon from '@plone/volto/components/theme/Icon/Icon'; // Assuming Icon is already imported
import { FormFieldWrapper } from '@plone/volto/components/manage/Widgets';
import rightSVG from '@plone/volto/icons/right-key.svg';
import downSVG from '@plone/volto/icons/down-key.svg';
import AnimateHeight from 'react-animate-height';
import CheckboxWidget from '@plone/volto/components/manage/Widgets/CheckboxWidget';
import FileWidget from '@plone/volto/components/manage/Widgets/FileWidget';
import TextWidget from '@plone/volto/components/manage/Widgets/TextWidget';
import topLeftSVG from '~/icons/top-left.svg';
import topRightSVG from '~/icons/top-right.svg';
import bottomLeftSVG from '~/icons/bottom-left.svg';
import bottomRightSVG from '~/icons/bottom-right.svg';
import { useIntl, defineMessages } from 'react-intl';

const messages = defineMessages({
  watermark: {
    id: 'watermark',
    defaultMessage: 'Watermark',
  },
  enableWatermark: {
    id: 'enableWatermark',
    defaultMessage: 'Enable',
  },
  enableWatermarkDescription: {
    id: 'enableWatermarkDescription',
    defaultMessage: 'Display a text/image watermark',
  },
  position: {
    id: 'position',
    defaultMessage: 'Position',
  },
  type: {
    id: 'type',
    defaultMessage: 'Type',
  },
  text: {
    id: 'text',
    defaultMessage: 'Text',
  },
  image: {
    id: 'image',
    defaultMessage: 'Image',
  },
  opacity: {
    id: 'opacity',
    defaultMessage: 'Opacity',
  },
});

const Watermark = (props) => {
  const {
    block,
    data,
    currentActiveFieldset,
    handleCurrentActiveFieldset,
    refreshPlayer,
    onChangeBlock,
  } = props;
  const intl = useIntl();

  const ICON_MAP = {
    'top-left': topLeftSVG,
    'top-right': topRightSVG,
    'bottom-left': bottomLeftSVG,
    'bottom-right': bottomRightSVG,
  };

  return (
    <div
      key="watermark"
      id="blockform-fieldset-watermark"
      className="watermark"
    >
      <Accordion.Title
        active={currentActiveFieldset === 3}
        index={3}
        onClick={handleCurrentActiveFieldset}
      >
        <>{intl.formatMessage(messages.watermark)}</>
        {currentActiveFieldset === 3 ? (
          <Icon name={downSVG} size="20px" />
        ) : (
          <Icon name={rightSVG} size="20px" />
        )}
      </Accordion.Title>
      <Accordion.Content active={currentActiveFieldset === 3}>
        <AnimateHeight
          animateOpacity
          duration={500}
          height={currentActiveFieldset === 3 ? 'auto' : 2}
        >
          <CheckboxWidget
            id="watermark-enabled"
            key="watermark-enabled"
            title={intl.formatMessage(messages.enableWatermark)}
            value={data.options?.watermark?.enabled}
            onChange={(id, value) => {
              onChangeBlock(block, {
                ...data,
                options: {
                  ...data.options,
                  watermark: {
                    position: 'top-right',
                    type: 'text',
                    text: 'Watermark',
                    opacity: 0.4,
                    ...data.options?.watermark,
                    enabled: value,
                  },
                },
              });
              refreshPlayer();
            }}
            block={block}
            description={intl.formatMessage(
              messages.enableWatermarkDescription,
            )}
          />
          <Segment
            className="attached"
            style={{
              display: data.options?.watermark?.enabled ? 'block' : 'none',
            }}
          >
            <FormFieldWrapper
              id="position"
              title={intl.formatMessage(messages.position)}
            >
              <div className="align-watermark">
                <Button.Group>
                  {Object.keys(ICON_MAP).map((action) => (
                    <Button
                      key={action}
                      icon
                      basic
                      aria-label={action}
                      onClick={() => {
                        onChangeBlock(block, {
                          ...data,
                          options: {
                            ...data.options,
                            watermark: {
                              ...data.options.watermark,
                              position: action,
                            },
                          },
                        });
                        refreshPlayer();
                      }}
                      active={data.options?.watermark?.position === action}
                    >
                      <Icon name={ICON_MAP[action]} size="17px" />
                    </Button>
                  ))}
                </Button.Group>
              </div>
            </FormFieldWrapper>
            <FormFieldWrapper
              id="type"
              title={intl.formatMessage(messages.type)}
            >
              <div className="type-wrapper">
                <Radio
                  id="field-radio-text"
                  name={`field-radio-text`}
                  checked={data.options?.watermark?.type === 'text'}
                  value="text"
                  onChange={(event, { value }) => {
                    onChangeBlock(block, {
                      ...data,
                      options: {
                        ...data.options,
                        watermark: {
                          ...data.options.watermark,
                          type: value,
                        },
                      },
                    });
                    refreshPlayer();
                  }}
                  label={
                    <label htmlFor={`field-radio-text`}>
                      {intl.formatMessage(messages.text)}
                    </label>
                  }
                />
                <Radio
                  id="field-radio-img"
                  name={`field-radio-img`}
                  checked={data.options?.watermark?.type === 'img'}
                  onChange={(event, { value }) => {
                    onChangeBlock(block, {
                      ...data,
                      options: {
                        ...data.options,
                        watermark: {
                          ...data.options.watermark,
                          type: value,
                        },
                      },
                    });
                    refreshPlayer();
                  }}
                  value="img"
                  label={
                    <label htmlFor={`field-radio-img`}>
                      {intl.formatMessage(messages.image)}
                    </label>
                  }
                />
              </div>
            </FormFieldWrapper>
            <div
              style={{
                display:
                  data.options?.watermark?.type === 'text' ? 'block' : 'none',
              }}
            >
              <TextWidget
                id="watermark-type-text-input"
                title={intl.formatMessage(messages.text)}
                value={data.options?.watermark?.text}
                onChange={(id, value) => {
                  onChangeBlock(block, {
                    ...data,
                    options: {
                      ...data.options,
                      watermark: {
                        ...data.options.watermark,
                        text: value,
                      },
                    },
                  });
                  refreshPlayer();
                }}
              />
            </div>
            <div
              style={{
                display:
                  data.options?.watermark?.type === 'img' ? 'block' : 'none',
              }}
            >
              <FileWidget
                id="watermark-type-img-input"
                title={intl.formatMessage(messages.image)}
                value={data.options?.watermark?.image}
                onChange={(id, value) => {
                  if (value) {
                    onChangeBlock(block, {
                      ...data,
                      options: {
                        ...data.options,
                        watermark: {
                          ...data.options.watermark,
                          image: value,
                        },
                      },
                    });
                    refreshPlayer();
                  } else {
                    const { image: _img, ...restWatermark } =
                      data.options?.watermark || {};
                    onChangeBlock(block, {
                      ...data,
                      options: {
                        ...data.options,
                        watermark: restWatermark,
                      },
                    });
                  }
                }}
                key="watermark-type-img-input"
                block={block}
              />
            </div>
            <div
              style={{
                display: data.options?.watermark?.enabled ? 'block' : 'none',
              }}
            >
              <FormFieldWrapper
                id="watermark-opacity"
                title={intl.formatMessage(messages.opacity)}
              >
                <Input
                  min={0}
                  max={1}
                  name="watermark-opacity-range"
                  onChange={(event, { value }) => {
                    onChangeBlock(block, {
                      ...data,
                      options: {
                        ...data.options,
                        watermark: {
                          ...data.options.watermark,
                          opacity: value,
                        },
                      },
                    });
                    refreshPlayer();
                  }}
                  step={0.1}
                  type="range"
                  value={data.options?.watermark?.opacity || 0}
                />
              </FormFieldWrapper>
            </div>
          </Segment>
        </AnimateHeight>
      </Accordion.Content>
    </div>
  );
};

export default Watermark;
